<select *ngIf="!processing" class="form-control" name="bg" id="" [disabled]="disabled" [ngModel]="defaultSelect || options[0].value" ng-init="Choose Gender" 
      (change)="patchType($event)">
      <option *ngFor="let option of options" [value]="option.value" [disabled]="option.value === null || option.value === undefined || option.value === '0'" translate>{{ option.description }}</option>
</select>

<select *ngIf="processing" class="form-control" name="bg" id="" [disabled]="disabled" (change)="patchType($event)" [ngModel]="defaultSelect || null"  [ngClass]="{'no-arrow': hideArrow}">
      <option value="null" [selected]="!defaultSelect" disabled translate>user.selectDefaultPreset</option>
      <option *ngFor="let option of options" value="{{option.id}}" [selected]="option.id == defaultSelect">{{option.name}}</option>
</select>
